import banner1 from '../img/banners/banner(1).jpg';
import banner2 from '../img/banners/banner(2).JPG';
import banner3 from '../img/banners/banner(3).JPG';
import banner4 from '../img/banners/banner(4).JPG';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Link } from "react-router-dom";


function Banners()
{
    const banners=[
        { id: 1, title: 'محصولات جدید', image: banner1,link:'/136-جدید' },
        { id: 2, title: 'فیروزه', image: banner2,link:'/52-سنگ-فیروزه' },
        { id: 3, title: 'جید', image: banner3,link:'/53-سنگ-جید' },
        { id: 4, title: 'مروارید', image: banner4,link:'/14-مروارید' },
        //{ id: 4, title: 'dddd', image: '/img/banner(4).jpg' },
    ];
    return(
        <div className="banner-content mt-4">
        <Swiper
        breakpoints={{
          // تنظیمات برای حالت موبایل
          0: {
            spaceBetween: 10,
            slidesPerView: 2.5, // نمایش 2 اسلاید
          },
          // تنظیمات برای حالت دسکتاپ
          768: {
            spaceBetween: 50,
            slidesPerView: 4, 
          },
        }}
      >
        {banners.map((banner,index) => (
            <SwiperSlide key={index}>
                <Link to={banner.link} className='d-flex flex-column text-center text-decoration-none text-dark' >
                    <img key={banner.id} src={banner.image} alt={banner.title} />
                    <span className='mt-4'>{banner.title}</span>
                </Link>
            </SwiperSlide>
        ))}
        
      </Swiper>
      </div>
    );
    return(
        <div className="banner-content mt-4">
           <div className='d-flex justify-content-between'>
                {banners.map((banner) => (
                    <a className='d-flex flex-column align-items-center text-decoration-none text-dark' href={banner.link}>
                        <img key={banner.id} src={banner.image} alt={banner.title} />
                        <span className='mt-4'>{banner.title}</span>
                    </a>
                ))}
           </div>
        </div>
    );
}
export default Banners;